export default (name) => name.replace(/_[ABNR0-9]*$/, '');
